module.exports = __webpack_public_path__ + "img/baby-breech-complete.1cea4b7e.png";